export const DEFAULT_WIDTH = 200;
export const DEFAULT_HEIGHT = 50;
export const DEFAULT_MIN_WIDTH = 50;
